module.exports = __webpack_public_path__ + "img/starIcon.f64cf47e.svg";